import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { MetaTagsListState, META_TAGS_SLICE_NAME } from './models';

export const metaTagsSelector = (state: RootState): MetaTagsListState => state[META_TAGS_SLICE_NAME];

export const selectMetaTagsIsLoading = createSelector(metaTagsSelector, (state: MetaTagsListState) => state.isLoading);

export const selectMetaTagsList = createSelector(metaTagsSelector, (state: MetaTagsListState) => state.metaTagsList);

export const selectQuery = createSelector(metaTagsSelector, (state: MetaTagsListState) => state.query);
